// extracted by mini-css-extract-plugin
export default {"tooltip":"ChartTooltip_tooltip__WzCyc","dot":"ChartTooltip_dot__2uUPE"};